import {Routes,Route} from "react-router-dom"
import Home from "./Home"
import Dashboard from "./Dashboard"
import Setting from "./Settings"
import Login from "./Login"
import PageNotFound from "./PageNotFound"
import PrivateRoutes from "../Components/PrivateRoutes"
function AllRoutesPages(){
  return(
    <Routes>
        <Route path="/" element={<Home/>}></Route>
        <Route path="/dashboard" element={<PrivateRoutes><Dashboard/></PrivateRoutes>}></Route>
        <Route path="/setting" element={<PrivateRoutes><Setting/></PrivateRoutes>}></Route>
        <Route path="/login" element={<Login/>}></Route>
        <Route path="*" element={<PageNotFound/>}></Route>
    </Routes>
  )
}

export default AllRoutesPages